export const YOUTUBE_OWNERS_IDS: { [cms: string]: string } = {
  Logicomix: 'AkXOB7W-CcJiy62BsVB4vg',
  'Logicomix Network': 'yFA-9sNB2Ve3Q4pLaaI6fg',
  Endemol: 'LYpkkKtsyeENfUXYiQ8wYA',
  Bump: 'SlqNIpL-0tRhIxNNcFa2ZQ',
  'TV5 Monde': 'hFt5R3W6_i0TH-dUe0AUsw',
  'France TV Médias': 'jBheEYYwdbDV7p4iM08yOA',
}

export const PAGE_SIZES = [10, 25, 50, 100]
export const DEFAULT_PAGE_SIZE = PAGE_SIZES[2]
